import { lazy } from 'react'

import { RouteConfig } from 'packages/route'

/**
 * 定义路由
 *
 * @returns 路由定义
 */
export const getRoutes: () => RouteConfig[] = () => [
  {
    path: 'admin/activities',
    name: 'AdminActivities',
    getTitle: () => '活动管理',
    component: lazy(() =>
      import('./pages/List').then((m) => ({
        default: m.AdminActivities,
      }))
    ),
  },
]

export const modalRoutes = [
  {
    name: 'EditFullModel',
    getTitle: () => '编辑活动',
    component: lazy(() =>
      import('./pages/Edit').then((m) => ({
        default: m.EditFullModal,
      }))
    ),
  },
  {
    name: 'AddFullModel',
    getTitle: () => '新建活动',
    component: lazy(() =>
      import('./pages/Edit').then((m) => ({
        default: m.EditFullModal,
      }))
    ),
  },
  {
    name: 'DetailFullModel',
    getTitle: () => '查看活动',
    component: lazy(() =>
      import('./pages/Detail').then((m) => ({
        default: m.DetailFullModal,
      }))
    ),
  },
]
